/* global gsap, ScrollTrigger */

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.lock-screen-section');
    if (!sections.length) {return;}

    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();

    sections.forEach(section => {
        const detailsInner = gsap.utils.toArray(section.querySelectorAll('.lss-content-inner'));
        const photos = gsap.utils.toArray(section.querySelectorAll('.desktopPhoto'));
        const row = section.querySelector('.lss-row');
        const rightCol = section.querySelector('.right');

        // Skip if structure missing
        if (!row || !rightCol || !detailsInner.length || !photos.length) {return;}

        // Set first photo active
        photos.forEach((photo, index) => {
            photo.classList.toggle('active', index === 0);
        });

        mm.add('(min-width: 768px)', () => {
            // Pin right column per section
            ScrollTrigger.create({
                trigger: row,
                start: 'top top+=80px',
                end: 'bottom bottom-=200px',
                pin: rightCol,
                pinSpacing: true,
                markers: false,
            });

            // Scroll-linked photo updates + fade parentDetails
            detailsInner.forEach(detailInner => {
                const parentDetail = detailInner.closest('.lss-content-item');
                const target = parentDetail.getAttribute('data-target');
                const photo = section.querySelector(target);

                // Photo update on scroll
                ScrollTrigger.create({
                    trigger: parentDetail,
                    start: 'top center+=100px',
                    end: 'bottom center-=80px',
                    onEnter: () => setActive(photo),
                    onEnterBack: () => setActive(photo),
                    markers: false,
                });
            });

            const contentItems = document.querySelectorAll('.lss-content-item');
            if (!contentItems.length) {return;}

            contentItems.forEach(item => {
                gsap.to(item, {
                    opacity: 0,
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 150px',
                        end: 'top 65px',
                        scrub: true,
                        markers: false,
                        toggleActions: 'play none none none', // ensures it stays at 0 after fade
                    },
                });
            });

        });

        function setActive(photo) {
            photos.forEach(p => p.classList.remove('active'));
            if (photo) {photo.classList.add('active');}
        }
    });
});